// @flow

import React from 'react'
import { compose } from 'recompose'
import { Trans, withI18n } from '@lingui/react'

import withStyles from 'material-ui/styles/withStyles'
import Grid from 'material-ui/Grid'
import Typography from 'material-ui/Typography'

import Section from 'components/Section'

type Props = {
  classes: Object,
  i18n: Object,
}

const StoritveSection = ({ classes, i18n }: Props) => (
  <Section className={classes.root} anchor={i18n._('storitve.slug')}>
    <Grid className={classes.container} container spacing={0}>
      <Grid className={classes.intro} item xs={12}>
        <Typography className={classes.title} variant={'headline'}>
          <Trans id='storitve.title' />
        </Typography>
        <Typography className={classes.lead} variant={'subheading'}>
          <Trans id='storitve.lead' />
        </Typography>
      </Grid>
      <Grid className={classes.content} item xs={12}>
        <Grid className={classes.grid} container spacing={16}>
          <Grid className={classes.column} item xs={12} sm={12} md={4}>
            <img
              className={classes.image}
              src={require('./images/phone.svg')}
              alt={i18n._('storitve.item1')}
            />
            <Typography className={classes.text} variant={'body2'}>
              <Trans id='storitve.item1' />
            </Typography>
          </Grid>
          <Grid className={classes.column} item xs={12} sm={12} md={4}>
            <img
              className={classes.image}
              src={require('./images/heartbeat.svg')}
              alt={i18n._('storitve.item2')}
            />
            <Typography className={classes.text} variant={'body2'}>
              <Trans id='storitve.item2' />
            </Typography>
          </Grid>
          <Grid className={classes.column} item xs={12} sm={12} md={4}>
            <img
              className={classes.image}
              src={require('./images/racks.svg')}
              alt={i18n._('storitve.item3')}
            />
            <Typography className={classes.text} variant={'body2'}>
              <Trans id='storitve.item3' />
            </Typography>
          </Grid>
          {/*
          <Grid className={classes.column} item xs={12} sm={12} md={4}>
            <img
              className={classes.image}
              src={require('./images/design.svg')}
              alt={i18n._('storitve.item4')}
              />
            <Typography className={classes.text} variant={'body2'}>
              <Trans id='storitve.item4' />
            </Typography>
          </Grid>
          */}
          <Grid className={classes.column} item xs={12} sm={12} md={4}>
            <img
              className={classes.image}
              src={require('./images/project.svg')}
              alt={i18n._('storitve.item5')}
            />
            <Typography className={classes.text} variant={'body2'}>
              <Trans id='storitve.item5' />
            </Typography>
          </Grid>
          <Grid className={classes.column} item xs={12} sm={12} md={4}>
            <img
              className={classes.image}
              src={require('./images/network.svg')}
              alt={i18n._('storitve.item6')}
            />
            <Typography className={classes.text} variant={'body2'}>
              <Trans id='storitve.item6' />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  </Section>
)

const styles = theme => ({
  root: {
    paddingBottom: theme.spacing.unit * 8,
  },
  container: {
    maxWidth: '1140px',
    margin: '0 auto',
  },

  intro: {
    //
  },
  title: {
    marginBottom: theme.spacing.unit * 4,
  },
  lead: {
    //
  },

  content: {
    //
  },
  grid: {
    marginTop: theme.spacing.unit * 2,
    justifyContent: 'center',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: theme.spacing.unit * 4,
  },
  image: {
    marginBottom: theme.spacing.unit * 3,
    height: '120px',
  },
  text: {
    height: '60px',
    letterSpacing: '0.5px',
    fontFamily: 'Gotham, sans-serif',
    fontWeight: '700',
    textAlign: 'center',
    textTransform: 'uppercase',
  },
})

export default compose(
  withI18n(),
  withStyles(styles),
)(StoritveSection)



// WEBPACK FOOTER //
// ./src/components/Storitve/index.js